import { useQuery } from '@tanstack/react-query';
import styled from 'styled-components';
import { withAppHOC } from '../../hoc';
import { StyledContentContainer } from '../../components/styled';
import { MessageBox } from '../../components/FormElements';
import Loader from '../../components/Loader/Loader';
import PageHeader from '../../components/PageHeader/PageHeader';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import API from '../../api';
import { RESPONSE_STATUSES } from '../../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faCalculator,
  faEnvelope,
  faLocation,
  faMobileAlt,
} from '@fortawesome/free-solid-svg-icons';

const StyledFirmDetailsContainer = styled.section`
  padding: 40px 20px 20px 20px;
  span {
    display: block;
    font-size: 13px;
    font-weight: normal;
    color: #ce8b54;
    text-transform: uppercase;
    margin: 0px 0px 10px;
  }
  h1 {
    font-size: 20px;
    font-weight: normal;
    color: #000;
    margin: 0px;
    padding: 0px;
    margin-bottom: 20px;
    text-transform: uppercase;
  }
  address {
    font-size: 15px;
    color: #000;
    margin: 0px;
    padding: 0px;
    font-weight: normal;
    font-style: normal;
    margin-bottom: 20px;
    max-width: 500px;
    line-height: 24px;
  }
  p {
    font-size: 15px;
    color: #000;
    margin: 0px;
    padding: 0px;
    font-weight: normal;
    font-style: normal;
    margin-bottom: 20px;
  }
`;

const StyledGridBox = styled.section`
  display: flex;
  gap: 20px;
`;

const StyledGridItem = styled.section`
  &:first-child {
    width: auto;
    height: auto;
    min-width: 80px;
    min-height: 80px;
    display: flex;
    justify-content: center;

    padding: 0px;
    color: #ce8b54;
    svg {
      font-size: 50px;
    }
  }
  &:last-child {
    flex: 1;
  }
`;

const FirmDetails = () => {
  const readData = async () => {
    try {
      const response = await API.get(`/meta/firm-details`);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ['firm_details'],
    queryFn: readData,
  });

  const renderPageHeading = () => <PageHeader title="Company Profile" />;

  if (isLoading) {
    return (
      <>
        {renderPageHeading()}
        <StyledContentContainer>
          <LoadingSpinner />
        </StyledContentContainer>
      </>
    );
  }

  if (error) {
    return (
      <>
        {renderPageHeading()}
        <StyledContentContainer>
          <MessageBox
            status={RESPONSE_STATUSES.FAILED}
            message={error.message}
          />
        </StyledContentContainer>
      </>
    );
  }

  return (
    <>
      <Loader isLoading={isLoading} />
      {renderPageHeading()}
      <StyledContentContainer>
        <StyledFirmDetailsContainer>
          <StyledGridBox>
            <StyledGridItem>
              <FontAwesomeIcon icon={faBuilding} />
            </StyledGridItem>
            <StyledGridItem>
              <span>Legal Name</span>
              <h1>{data?.data?.firmName}</h1>
            </StyledGridItem>
          </StyledGridBox>

          <StyledGridBox>
            <StyledGridItem>
              <FontAwesomeIcon icon={faLocation} />
            </StyledGridItem>
            <StyledGridItem>
              <span>Head Office</span>
              <address>{data?.data?.firmAddress}</address>
            </StyledGridItem>
          </StyledGridBox>

          <StyledGridBox>
            <StyledGridItem>
              <FontAwesomeIcon icon={faCalculator} />
            </StyledGridItem>
            <StyledGridItem>
              <span>GST Number</span>
              <p>{data?.data?.gstNumber}</p>
            </StyledGridItem>
          </StyledGridBox>

          <StyledGridBox>
            <StyledGridItem>
              <FontAwesomeIcon icon={faMobileAlt} />
            </StyledGridItem>
            <StyledGridItem>
              <span>Support Number</span>
              <p>{data?.data?.supportNumber}</p>
            </StyledGridItem>
          </StyledGridBox>

          <StyledGridBox>
            <StyledGridItem>
              <FontAwesomeIcon icon={faEnvelope} />
            </StyledGridItem>
            <StyledGridItem>
              <span>Support Email</span>
              <p>{data?.data?.supportEmail}</p>
            </StyledGridItem>
          </StyledGridBox>
        </StyledFirmDetailsContainer>
      </StyledContentContainer>
    </>
  );
};

export default withAppHOC(FirmDetails);
